module.exports = __webpack_public_path__ + "static/voice-user-interfaces-92928cea7eee8ca00be8debfb402059f.jpg";